import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { PaneModel } from "./usePanesState";
import TabBar, { AddDocumentType } from "./TabBar";

const PaneColumn: React.FC<{
  pane: PaneModel;
  allTabIds: string[];
  onClose: () => void;
  onSplitTab: (tabId: string) => void;
  onActivateTab: (tabId: string) => void;
  renderTabContent: (tabId: string) => React.ReactNode;
  getTabTitle?: (tabId: string) => string;
  getTabUnsaved?: (tabId: string) => boolean;
  onAddDocument?: (type: AddDocumentType) => void;
  onRenameTab?: (tabId: string, newName: string) => void;
  onRemoveTab?: (tabId: string) => void;
}> = ({
  pane,
  onSplitTab,
  onActivateTab,
  renderTabContent,
  getTabTitle,
  getTabUnsaved,
  onAddDocument,
  onRenameTab,
  onRemoveTab,
}) => {
  const active = pane.activeTabId || pane.tabIds[0];
  // Make the content area a drop target to append at end
  const { setNodeRef: setContentDropRef } = useDroppable({
    id: `${pane.id}::content::end`,
  });
  return (
    <div className="da-pane-column">
      <TabBar
        paneId={pane.id}
        tabIds={pane.tabIds}
        activeTabId={active}
        onActivate={onActivateTab}
        onSplit={onSplitTab}
        getTabTitle={getTabTitle}
        getTabUnsaved={getTabUnsaved}
        onAddDocument={onAddDocument}
        onRenameTab={onRenameTab}
        onRemoveTab={onRemoveTab}
      />
      <div className="da-pane-content" ref={setContentDropRef}>
        {active ? (
          renderTabContent(active)
        ) : (
          <div className="da-empty">No tab</div>
        )}
      </div>
    </div>
  );
};

export default PaneColumn;
